import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { Ellipsis } from '#src/atoms/typography/Ellipsis/index.tsx';
import { LabelS } from '#src/atoms/typography/index.tsx';
import { DumbClubAvatar } from '#src/components/club/DumbClubAvatar/index.tsx';

const Wrapper = styled(Vertical).attrs({ gap: 1, center: true })`
  justify-content: flex-start;
`;

const Avatar = styled(DumbClubAvatar)`
  --size: 3em;
  font-size: unset;
`;

type ClubProps = {
  name?: string;
  avatarUrl?: string | null;
  avatar?: ReactNode;
};

type Props = {
  team: ClubProps;
  bold?: boolean;
  Label?: typeof LabelS;
};

export const NamedClubAvatar = ({
  team,
  bold = false,
  Label = LabelS,
}: Props) => {
  const { name, avatar, avatarUrl } = team;
  return (
    <Wrapper>
      {avatar || <Avatar club={{ name, avatarUrl }} />}
      <Ellipsis>
        <Label bold={bold}>{name}</Label>
      </Ellipsis>
    </Wrapper>
  );
};
